<template lang="pug">
b-modal#updatePaymentOptionDesc(
  ref="updatePaymentOptionDesc"
  :title="$t('ui.combine.change_payment_option_desc')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.payment_mode')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="payment_mode"
        required
        type="text"
        :dirty="$v.payment_mode.$dirty"
        :error="$v.payment_mode.$error"
        v-model.trim.lazy="$v.payment_mode.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.payment_mode" :name="$t('ui.payment_mode')")
    b-form-group(:label="$t('ui.description')").mb-0
      DebounceInput(
        ref="payment_desc"
        required
        type="text"
        :dirty="$v.payment_desc.$dirty"
        :error="$v.payment_desc.$error"
        v-model.trim.lazy="$v.payment_desc.$model"
        :disabled="loading"
        size="sm"
        :operatorID="operatorID"
      )
      ValidateResult(:value="$v.payment_desc" :name="$tc('ui.description')")
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      payment_mode: "",
      payment_desc: null,
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  validations: {
    payment_mode: {
      required
    },
    payment_desc: {
      required
    },
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.paymentOptionOperatorUpdateDescUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          payment_mode: this.payment_mode,
          payment_desc: this.payment_desc
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.updatePaymentOptionDesc.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "change_payment_option_desc", this.feedback.status);
                  this.$refs.updatePaymentOptionDesc.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function() {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.payment_mode = "";
      this.payment_desc = null
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.payment_mode = this.item.payment_mode;
      this.payment_desc = this.item.payment_desc;
      this.$refs.payment_desc.$el.focus();
    }
  }
};
</script>
